import { useInView } from "react-intersection-observer";
import { useNavigate } from "react-router";
import { ArticleDataObject } from "@app/types/Cue";
import {
  getArticleAuthorNames,
  getArticleChapter1,
  getArticleKeywords,
  getArticleLevel2,
  getArticleStoryThread,
} from "@components/GAData/helper";
import { dayjsSingaporeTimezone, getEnvironment } from "@util/constant";
import { getEnvironmentDomain } from "@util/helpers";
import dayjs from "dayjs";
import posthog from "posthog-js";

export const useHookUpdateUrlArticle = (
  urlPath: string,
  isNavigate: boolean,
  article: ArticleDataObject
) => {
  const navigate = useNavigate();

  const { ref } = useInView({
    threshold: 0.01,
    onChange: (inView) => {
      if (!inView || !isNavigate || !article?.id) return;

      navigate(urlPath, { preventScrollReset: true });

      if (typeof window === "undefined") return;

      const publishedDate = dayjs(article?.updated)
        .tz(dayjsSingaporeTimezone)
        .format("YYYY-MM-DD HH:mm:ss");

      window.dataLayer = window.dataLayer || [];

      (window.dataLayer as object[]).push({
        ...window._data,
        ...{
          event: "virtual_pv",
          virtual_url: urlPath.replace("/", ""),
          cue_articleid: article?.id,
          articleid: article?.id,
          author: getArticleAuthorNames(
            article?.authors,
            article.relatedContributorProfile
          ),
          chapter1: article?.sections?.[0]
            ? getArticleChapter1(article?.sections?.[0])
            : "",
          contentcat: article?.paywall?.contentAccess ? 2 : 1,
          contenttype: "1",
          keyword: getArticleKeywords(article.tags || []),
          level2: article?.sections?.[0]
            ? getArticleLevel2(article?.sections[0])
            : "",
          pubdate: publishedDate,
          title: article?.title,
          story_threads: getArticleStoryThread(
            article.tags || []
          )?.name.toLowerCase(),
        },
      });

      // For PostHog tracking
      const currentUrl = getEnvironmentDomain(getEnvironment()) + urlPath;
      posthog.capture("$pageview", {
        $pathname: urlPath,
        $current_url: currentUrl,
      });
    },
  });

  return { ref };
};
